import React from 'react'

import { Divider } from '@chakra-ui/react'
import { useSelector } from 'react-redux'

import { districtOptions, staffRoles } from '../../../constants'
import { FilterInput, FilterMenuBase } from '../../ui'

const StaffFilterMenu = ({ isOpen, onClose, filterButtonRef }) => {
  const filters = useSelector(state => state.directory.filters)
  const user = useSelector(state => state.auth.user)
  return (
    <FilterMenuBase
      heading='Staff Filters'
      store='directory'
      buttonRef={filterButtonRef}
      isOpen={isOpen}
      onClose={onClose}
      activeFilters={
        Object.keys(filters).filter(
          key => !['order_by', 'search'].includes(key)
        ).length
      }
    >
      <FilterInput
        label='Role'
        filterKey='role__in'
        multiSelect
        store='directory'
        options={staffRoles}
      />
      <FilterInput
        label='Council District'
        filterKey='district__in'
        multiSelect
        store='directory'
        placeholder='Filter by district'
        options={districtOptions}
      />
      {user.is_admin && (
        <>
          <Divider />
          <FilterInput
            filterKey='show_inactive'
            store='directory'
            placeholder='Show inactive users'
            inputType='checkbox'
            hideTags
          />
        </>
      )}
    </FilterMenuBase>
  )
}

export default StaffFilterMenu
